/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type SendMessageAttachment = {
  /**
   * The chat attachment asset returned by assets.uploadChatAttachment.
   */
  assetId: string;
  /**
   * The file name to show the assistant. Falls back to the stored asset name.
   */
  name?: string | undefined;
};

/** @internal */
export type SendMessageAttachment$Outbound = {
  asset_id: string;
  name?: string | undefined;
};

/** @internal */
export const SendMessageAttachment$outboundSchema: z.ZodMiniType<
  SendMessageAttachment$Outbound,
  SendMessageAttachment
> = z.pipe(
  z.object({
    assetId: z.string(),
    name: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      assetId: "asset_id",
    });
  }),
);

export function sendMessageAttachmentToJSON(
  sendMessageAttachment: SendMessageAttachment,
): string {
  return JSON.stringify(
    SendMessageAttachment$outboundSchema.parse(sendMessageAttachment),
  );
}
